import { cloneElement, Component, ReactElement } from 'react';

interface FocusTrapProps {
    children: (options: { focused: boolean; onFocus: () => void; onBlur: () => void }) => ReactElement<{
        onFocus: () => void;
        onBlur: () => void;
    }>;
}

interface State {
    focused: boolean;
}

class FocusTrap extends Component<FocusTrapProps, State> {
    public state: State = {
        focused: false,
    };

    public render() {
        return cloneElement(
            this.props.children({
                focused: this.state.focused,
                onFocus: this._onFocus,
                onBlur: this._onBlur,
            }),
            {
                onFocus: this._onFocus,
                onBlur: this._onBlur,
            }
        );
    }

    private _onFocus = () => {
        this.setState({
            focused: true,
        });
    };

    private _onBlur = () => {
        this.setState({
            focused: false,
        });
    };
}

export default FocusTrap;
